export default __webpack_public_path__ + "images/license-riscage-1.b90e43aa005860e85e4c00a88ae43a12.png";